/***
 * 订单关怀接口-下单关怀对接部分
 */
import { post, get,postJson,deleteApi } from '../axios'

const RESOURCE_BASE_PATH = ''
// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/remind-task'


/***
 * 查询任务列表
 * @param p
 */
export const page = p => get(`/remind-task/page`, p)

/***
 * 查询所有提醒开启状态信息
 * @param p
 */
export const openState = p => get(`/remind-task/all/open-state`, p)

/***
 * 查询自营提醒开启状态信息
 * @param p
 */
 export const openSelfState = p => get(`/remind-task/self/open-state`, p)

/***
 * 今天催付信息
 * @param p
 */
export const getRemind = (p,query) => get(`/notpayremind/getRemind/${p}`,query)

export const getRemindMerge = (query) => get(`/remind-task/mergeOrdersRemind/getRemind`,query)

/**
 * 往日催付信息
 * @param  p 
 */
export const getRemindByTime = p => postJson(`/notpayremind/getRemindByTime`,p)

export const getRemindByTimeMerge = (query) => postJson(`/remind-task/mergeOrdersRemind/getRemindByTime`,query)

/***
 * 7修改任务状态
 * @param p
 * @returns {*}
 */
export const updateStatus = p => post(`/remind-task/state/${p.configId}/${p.state}`, p)

/**
 * 任务优先级
 * @param  p 
 */
export const setRemindSort = p => post(`/remind-task/sort/${p.configId}/${p.sort}`)

/**
 * 新增任务
 * @param  p 
 */
export const addOrdersCare = p => postJson(`/remind-task/`,p)
/**
 * 任务信息
 * @param  id 
 */
export const orderCareInfo = id => get(`/remind-task/${id}`,)

/**
 * 查询挽回订单信息
 * @param  p 
 */
export const getRedeemInfo = p => get(`/notpayremind/getRedeemInfo`,p)

/**
 * 数据监控
 * @param  p 
 */
export const data = p => get(`/autoMarketingEffectAnalysis/data`,p)

/**
 * 挽回订单
 * @param  p 
 */
export const orderQuery = p => postJson(`/autoMarketingEffectAnalysis/orderQuery`,p)
/**
 * 删除任务
 * @param  p 
 */
export const delOrdersCare = id => deleteApi(`/remind-task/${id}`)

/**
 * 商品平均复购周期
 * @param  p 
 */
export const getItemBuyerRebuyAvg = p => getItemBuyerRebuyAvg(`/ware/getItemBuyerRebuyAvg`,p)


//导出弹框处理
export const  exportPopCommentSmsEffect = p => get(`/popCommentConfig/exportPopCommentSmsEffect?${p}`)
export const  exportNotpayremind= p => get(`/notpayremind/export?${p}`)




